export const pdfConstants = {
    ADDREMOVE_IMAGE: 'PDF_ADDREMOVE_IMAGE',
    UPDATEALL_IMAGES: 'PDF_UPDATEALL_IMAGES',
};